import {AfterViewInit, Component, Inject, OnInit, ViewChild} from "@angular/core";
import {
    ActionService,
    ConfigurationService,
    EntityService,
    ReportService,
    ResourceModule,
    SearchService
} from "@fedeltapointofsale/data-client";
import {
    FUIBreakpoints,
    FUINavigationChromeActionComponent,
    FUINavigationLink,
    FUINavigationLinkAvailability,
    FUINavigationService,
    FUIResponsiveService
} from "@fedeltapointofsale/ui";
import {Config, ServerAuth, WhoAmI} from "../../config";
import {Router} from "@angular/router";
import {AnalyticsService} from "../../analytics/analytics.service";
import {AnalyticEvent} from "../../analytics/analytic-event";

@Component({
    selector: "wbo-nav-layout",
    templateUrl: "./nav-layout.component.html",
    styleUrls: ["./nav-layout.component.scss"]
})
export class NavLayoutComponent implements OnInit, AfterViewInit {
    WhoAmI = WhoAmI;
    ServerAuth = ServerAuth;
    Config = Config;

    @ViewChild(FUINavigationChromeActionComponent) chromeAction: FUINavigationChromeActionComponent;

    integratedInstanceUrl: string;

    constructor(private navigationService: FUINavigationService,
                private configService: ConfigurationService,
                private responsiveService: FUIResponsiveService,
                private router: Router,
                private analyticsService: AnalyticsService,
                @Inject(ResourceModule.RESOURCE_NAMESPACE_KEY) private nameSpace: string) {
    }

    ngOnInit(): void {
        this.navigationService.initialiseNavigationLinks((link: FUINavigationLink) => {
            if (!link.nameSpace) {
                link.nameSpace = this.nameSpace;
            }

            let isAvailable: Promise<boolean> = Promise.resolve(true);
            if (link.plugin) {
                isAvailable = this.configService.getBoolean("plugin/" + link.plugin);
            }
            if (link.license) {
                isAvailable = isAvailable.then(available => available ? this.configService.getBoolean("license/" + link.license) : false);
            }
            link.availability = isAvailable.then(available => {
                if (!available) {
                    return Promise.resolve(FUINavigationLinkAvailability.UNAVAILABLE);
                }
                let isEnabled: Promise<boolean> = Promise.resolve(true);
                if (link.action === "search") {
                    isEnabled = SearchService.canSearch(this.configService, link.nameSpace + "/" + link.entity);
                } else if (link.action === "view") {
                    isEnabled = EntityService.canGetEntity(this.configService, link.nameSpace + "/" + link.entity)
                } else if (link.action === "create") {
                    isEnabled = EntityService.canCreateEntity(this.configService, link.nameSpace + "/" + link.entity)
                } else if (link.action === "update") {
                    isEnabled = EntityService.canUpdateEntity(this.configService, link.nameSpace + "/" + link.entity)
                } else if (link.action === "generate") {
                    isEnabled = ReportService.canRequestReport(this.configService, link.nameSpace + "/" + (link.entity ? link.entity : link.href))
                } else if (link.action === "perform") {
                    isEnabled = ActionService.canPerformAction(this.configService, link.nameSpace + "/" + (link.entity ? link.entity : link.href))

                }
                if (link.availabilityConfig) {
                    isEnabled = isEnabled.then(enabled => enabled ? this.configService.getBoolean(link.availabilityConfig) : false);
                }
                return isEnabled.then(enabled => Promise.resolve(enabled ? FUINavigationLinkAvailability.AVAILABLE : FUINavigationLinkAvailability.DISABLED));
            });
        });
    }

    ngAfterViewInit(): void {
        if (this.router.url === "/main/home") {
            if (!this.chromeAction.active && this.responsiveService.breakpointApplies(FUIBreakpoints.smallDown)) {
                this.chromeAction.toggle();
            }
        }
    }

    public hamburgerClicked(): void {
        this.analyticsService.trackEvent(AnalyticEvent.HEADER_HAMBURGER);
    }

    public logoClicked(): void {
        if (!WhoAmI.beaconScanOnly) {
            this.analyticsService.trackEvent(AnalyticEvent.HEADER_LOGO);
            this.router.navigate(["/main/home"]);
        }
    }

    public integratedInstanceSelected(url: string): void {
        window.open(url);
        setTimeout(() => this.integratedInstanceUrl = undefined);
    }
}
